import { LegalDocumentPage } from "components/LegalDocumentPage";
import {
  refundPolicyMeta,
  refundPolicySections,
} from "content/refundPolicyContent";

export default function RefundPolicyPage() {
  return (
    <LegalDocumentPage
      meta={refundPolicyMeta}
      sections={refundPolicySections}
      helmetDescription="Fortify Portal, Inc. Refund Policy — investor cancellation rights, failed offerings, and fund returns under NI 45-110."
    />
  );
}
